import Immutable from 'immutable';
import { GroupMember } from 'records/GroupMember';

export interface RawProjectGroup {
  projectid: string;
  groupid: string;
  name: string;
  createdby: string;
  createddate: string;
  lastmodifieddate: number;
  members: GroupMember[];
}

export interface ProjectGroupData {
  projectid: string;
  groupid: string;
  name: string;
  createdby: string;
  createddate: string;
  lastmodifieddate: number;
  members: GroupMember[];
}

const defaultValues: ProjectGroupData = {
  projectid: '',
  groupid: '',
  name: '',
  createdby: '',
  createddate: '',
  lastmodifieddate: 0,
  members: [],
};

export const ProjectGroupFactory = Immutable.Record(
  defaultValues,
  'ProjectGroup'
);

export class ProjectGroup extends ProjectGroupFactory {
  static deserialize(rawProjectGroup: RawProjectGroup): ProjectGroup {
    return new ProjectGroup({
      ...rawProjectGroup,
    });
  }

  serialize(): RawProjectGroup {
    return this.toJS();
  }
}
